import { useEffect, useRef, useState } from 'react';

export const useTimer = (initialDuration) => {
  const [seconds, setSeconds] = useState(initialDuration);
  const startTimeRef = useRef(null);
  const timerRef = useRef(null);

  const stop = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  };

  const updateSeconds = () => {
    if (!startTimeRef.current) {
      return;
    }

    const now = Math.floor(Date.now() / 1000);
    const elapsed = now - startTimeRef.current;
    const remaining = Math.max(0, initialDuration - elapsed);

    setSeconds(remaining);

    if (remaining <= 0) {
      stop();
    }
  };

  const start = (externalStartTime) => {
    stop();

    const now = Math.floor(Date.now() / 1000);

    startTimeRef.current = externalStartTime || now;

    updateSeconds();

    timerRef.current = setInterval(updateSeconds, 1000);
  };

  useEffect(() => {
    return stop;
  }, []);

  return { seconds, start, stop };
};
